import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';
import { ResponsiveTable } from './handlers/table';

@Directive({
  selector: '[responsive]'
})
export class ResponsiveDirective implements OnDestroy {

  private handler: ResponsiveDirectiveHandler;

  constructor(private el: ElementRef, private layout: LayoutService) {    
    switch (this.el.nativeElement.tagName) {
      case 'TABLE':
        this.handler = new ResponsiveTable(this.el.nativeElement, this.layout);
        break;      
    }
  }

  ngOnDestroy() {
    if (this.handler) this.handler.destroy();
  }

}

export interface ResponsiveDirectiveHandler {
  destroy(): void;
}
